module.exports = __webpack_public_path__ + "docs/minter-3a2d14.md";